import {Component} from '@angular/core';

@Component({
  selector: 'app-set-password-left-panel',
  templateUrl: './set-password-left-panel.component.html',
  styleUrls: ['./set-password-left-panel.component.css']
})
export class SetPasswordLeftPanelComponent {

}
